import Vue from 'vue'
import linkifyStr from 'linkifyjs/string'
import { trackEvent, trackEventBasic } from '@/services/AnalyticsWrapper'

Vue.mixin({
  methods: {
    $isError(e, status) {
      return (e.response && e.response.status === status)
    },

    $handleErrors(e) {
      if (e.response && e.response.status === 422 && typeof e.response.data.error !== 'string') {
        return this.$store.dispatch('Alerts/add', {
          trans: 'errors.validation',
          type: 'danger'
        })
      } else if (e.response && e.response.status === 404) {
        return this.$router.push({name: 'page404'})
      } else if (e.response && e.response.status === 403) {
        if (e.response.data.error) {
          return this.$store.dispatch('Alerts/add', {
            trans: 'errors.' + e.response.data.error,
            type: 'danger'
          })
        } else {
          this.$store.dispatch('Alerts/add', {
            trans: 'errors.forbidden',
            type: 'danger'
          })

          return this.$router.push({name: 'page404'})
        }
      } else if (e.response && e.response.status === 500 && typeof e.response.data.error !== 'string') {
        return this.$store.dispatch('Alerts/add', {
          trans: 'errors.internal',
          type: 'danger'
        })
      } else if (e.response && e.response.data.error) {
        return this.$store.dispatch('Alerts/add', {
          trans: 'errors.' + e.response.data.error,
          type: 'danger'
        })
      } else {
        console && console.error && console.error(e)
      }
    },

    $sanitize(value) {
      var div = document.createElement('div')
      div.innerHTML = value
      return div.textContent
    },

    $linkifyStr(str, options) {
      return linkifyStr(this.$sanitize(str), options)
    },

    $trackEvent: trackEvent,
    $trackEventBasic: trackEventBasic
  }
})



// WEBPACK FOOTER //
// ./src/config/utils.js